import { coerce, object, preprocess, record, string } from "zod";

const rawEnv = {
  backendUrl: import.meta.env.VITE_BACKEND_URL,
  tournamentUrl: import.meta.env.VITE_TOURNAMENT_URL,
  tournatedPlatformId: import.meta.env.VITE_TOURNATED_PLATFORM_ID,
  clientUrl: import.meta.env.VITE_CLIENT_URL,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API,
  authUrl: import.meta.env.VITE_AUTH_URL,
  imageKitUrl: import.meta.env.VITE_IMAGEKIT_ENDPOINT,
  imageKitPublicKey: import.meta.env.VITE_IMAGEKIT_PUBLIC_KEY,
  domainPlatformMap: import.meta.env.VITE_DOMAIN_PLATFORM_MAP,
  domainManagerMap: import.meta.env.VITE_DOMAIN_MANAGER_MAP,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE,
  maintenanceEnv: import.meta.env.VITE_MAINTENANCE_ENV,
};

const parseDomainPlatformMap = (raw?: string): Record<string, string> => {
  if (!raw) return {};
  return raw.split(",").reduce<Record<string, string>>((acc, entry) => {
    const trimmed = entry.trim();
    const eqIndex = trimmed.indexOf("=");
    if (eqIndex === -1) return acc;
    const domain = trimmed.slice(0, eqIndex).trim();
    const platformId = trimmed.slice(eqIndex + 1).trim();
    if (domain && platformId) {
      acc[domain] = platformId;
    }
    return acc;
  }, {});
};

const envSchema = object({
  backendUrl: string().url(),
  tournamentUrl: string().url(),
  tournatedPlatformId: coerce.number(),
  clientUrl: string().url(),
  googleMapsApiKey: string(),
  authUrl: string().url(),
  imageKitUrl: string().url(),
  imageKitPublicKey: string(),
  domainPlatformMap: preprocess(
    (val) => {
      try {
        if (typeof val !== "string" || !val.trim()) {
          return {};
        }
        return parseDomainPlatformMap(val);
      } catch {
        return {};
      }
    },
    record(string(), string())
  ),
  domainManagerMap: preprocess(
    (val) => {
      try {
        if (typeof val !== "string" || !val.trim()) {
          return {};
        }
        return parseDomainPlatformMap(val);
      } catch {
        return {};
      }
    },
    record(string(), string())
  ),
  sentryDsn: string().url().optional(),
  sentryEnvironment: string().optional(),
  sentryRelease: string().optional(),
  // Remote Config environment override for the maintenance notice (e.g. `stage-b`);
  // unset or blank → derived from `backendUrl`.
  maintenanceEnv: preprocess(
    (val) => (typeof val === "string" && val.trim() ? val.trim() : undefined),
    string().optional()
  ),
});

export const env = envSchema.parse(rawEnv);
